module.exports = "https://coursera_assets.s3.amazonaws.com/images/5663b209b18bb6fd849d5670ee6ba12c.jpg";